/**
 * Build-time env, read once and re-exported — the one place other modules
 * import config from, instead of reaching into `import.meta.env` themselves
 * (mirrors apps/physio-app/src/config/env.ts's pattern).
 *
 * Nothing here is secret: this bundle is served publicly from S3+CloudFront,
 * so anything in it is readable by anyone with a link (ADR-0009, and this
 * repo's apps/patient-web/.env.example says the same for VITE_API_BASE_URL).
 * A Sentry DSN is a public identifier by Sentry's own design — the same
 * reasoning apps/physio-app/src/config/env.ts already applies.
 */

export const API_BASE_URL: string =
  (import.meta.env['VITE_API_BASE_URL'] as string | undefined) ?? '';

/** Empty means "off" — see monitoring/sentry.ts's initPatientSentry (M0.7). */
export const SENTRY_DSN: string = (import.meta.env['VITE_SENTRY_DSN'] as string | undefined) ?? '';
